<template>
	<div id="help" class="window" role="tabpanel" aria-label="Ajuda">
		<div class="header">
			<SidebarToggle />
		</div>
		<div class="container">
			<h1 class="title">Ajuda</h1>

			<h2 class="help-version-title">
				<span>Sobre o PTnet Chat</span>
				<small> v{{ $store.state.serverConfiguration.ptnetversion }} </small>
			</h2>

			<div class="about">
				<p>
					O PTnet Chat &eacute; o cliente web oficial da rede PTnet. Este software
					&eacute; baseado no The Lounge e modificado pela PTnet. Para qualquer
					esclarecimento fala connosco no canal #PThelp ou por e-mail em
					suporte@ptnet.org.
				</p>
				<p>
					<a
						href="https://www.ptnet.org/"
						target="_blank"
						rel="noopener"
						class="website-link"
						>www.ptnet.org</a
					>
				</p>
				<p>
					<a
						href="https://www.ptnet.org/doc"
						target="_blank"
						rel="noopener"
						class="documentation-link"
						>Documenta&ccedil;&atilde;o da PTnet</a
					>
				</p>
				<p>
					<a
						href="https://www.ptnet.org/rede/suporte"
						target="_blank"
						rel="noopener"
						class="report-issue-link"
						>Reportar problema</a
					>
				</p>
			</div>

			<h2 class="help-version-title">
				<span>Sobre o The Lounge</span>
				<small> v{{ $store.state.serverConfiguration.version }} </small>
			</h2>

			<div class="about">
				<p>
					<a
						href="https://thelounge.chat/"
						target="_blank"
						rel="noopener"
						class="website-link"
						>thelounge.chat</a
					>
				</p>
				<p>
					<a
						href="https://thelounge.chat/docs/"
						target="_blank"
						rel="noopener"
						class="documentation-link"
						>Documenta&ccedil;&atilde;o do The Lounge</a
					>
				</p>
			</div>

			<h2>Atalhos de teclado</h2>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Alt</kbd> <kbd>Shift</kbd> <kbd>↓</kbd></span>
					<span v-else><kbd>⌥</kbd> <kbd>⇧</kbd> <kbd>↓</kbd></span>
				</div>
				<div class="description">
					<p>Alterna para a janela de status seguinte na lista de canais.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Alt</kbd> <kbd>Shift</kbd> <kbd>↑</kbd></span>
					<span v-else><kbd>⌥</kbd> <kbd>⇧</kbd> <kbd>↑</kbd></span>
				</div>
				<div class="description">
					<p>Alterna para a janela de status anterior lista de canais.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Alt</kbd> <kbd>Shift</kbd> <kbd>←</kbd></span>
					<span v-else><kbd>⌥</kbd> <kbd>⇧</kbd> <kbd>←</kbd></span>
				</div>
				<div class="description">
					<p>Colapsa a rede actual.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Alt</kbd> <kbd>Shift</kbd> <kbd>→</kbd></span>
					<span v-else><kbd>⌥</kbd> <kbd>⇧</kbd> <kbd>→</kbd></span>
				</div>
				<div class="description">
					<p>Expande a rede actual.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Alt</kbd> <kbd>↓</kbd></span>
					<span v-else><kbd>⌥</kbd> <kbd>↓</kbd></span>
				</div>
				<div class="description">
					<p>Alterna para a janela seguinte na lista de canais.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Alt</kbd> <kbd>↑</kbd></span>
					<span v-else><kbd>⌥</kbd> <kbd>↑</kbd></span>
				</div>
				<div class="description">
					<p>Alterna para a janela anterior na lista de canais.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Alt</kbd> <kbd>A</kbd></span>
					<span v-else><kbd>⌥</kbd> <kbd>A</kbd></span>
				</div>
				<div class="description">
					<p>Alterna para a primeira janela com mensagens por ler.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Alt</kbd> <kbd>S</kbd></span>
					<span v-else><kbd>⌥</kbd> <kbd>S</kbd></span>
				</div>
				<div class="description">
					<p>Activa o menu lateral.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Alt</kbd> <kbd>U</kbd></span>
					<span v-else><kbd>⌥</kbd> <kbd>U</kbd></span>
				</div>
				<div class="description">
					<p>Activa a lista de utilizadores do canal.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Alt</kbd> <kbd>J</kbd></span>
					<span v-else><kbd>⌥</kbd> <kbd>J</kbd></span>
				</div>
				<div class="description">
					<p>Vai para caixa de pesquisa de canal.</p>
				</div>
			</div>

			<h2>Atalhos de formatação</h2>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Ctrl</kbd> <kbd>K</kbd></span>
					<span v-else><kbd>⌘</kbd> <kbd>K</kbd></span>
				</div>
				<div class="description">
					<p>
						Marca o texto escrito após este atalho para ser colorizado. Depois do
						atalho, escreve um número inteiro entre
						<code>0—15</code> para selecionar a cor desejada, ou usa o menu de
						autocompletar para escolher um nome (ver abaixo).
					</p>
					<p>
						A cor de fundo pode ser definida com uma vírgula e outro número entre
						<code>0—15</code> a seguir à cor do texto (autocompletar também funciona).
					</p>
					<p>
						Pode ser consultada uma referência de cores
						<a
							href="https://modern.ircdocs.horse/formatting.html#colors"
							target="_blank"
							rel="noopener"
							>aqui</a
						>.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Ctrl</kbd> <kbd>B</kbd></span>
					<span v-else><kbd>⌘</kbd> <kbd>B</kbd></span>
				</div>
				<div class="description">
					<p>
						Marca o texto escrito depois deste atalho como
						<span class="irc-bold">negrito</span>.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Ctrl</kbd> <kbd>U</kbd></span>
					<span v-else><kbd>⌘</kbd> <kbd>U</kbd></span>
				</div>
				<div class="description">
					<p>
						Marca o texto escrito depois deste atalho como
						<span class="irc-underline">sublinhado</span>.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Ctrl</kbd> <kbd>I</kbd></span>
					<span v-else><kbd>⌘</kbd> <kbd>I</kbd></span>
				</div>
				<div class="description">
					<p>
						Marca o texto escrito depois deste atalho como
						<span class="irc-italic">itálico</span>.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Ctrl</kbd> <kbd>S</kbd></span>
					<span v-else><kbd>⌘</kbd> <kbd>S</kbd></span>
				</div>
				<div class="description">
					<p>
						Marca o texto escrito depois deste atalho como
						<span class="irc-strikethrough">riscado</span>.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Ctrl</kbd> <kbd>M</kbd></span>
					<span v-else><kbd>⌘</kbd> <kbd>M</kbd></span>
				</div>
				<div class="description">
					<p>
						Marca o texto escrito depois deste atalho como
						<span class="irc-monospace">monospace</span>.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<span v-if="!isApple"><kbd>Ctrl</kbd> <kbd>O</kbd></span>
					<span v-else><kbd>⌘</kbd> <kbd>O</kbd></span>
				</div>
				<div class="description">
					<p>
						Marca o texto escrito depois deste atalho para voltar à sua formatação
						original.
					</p>
				</div>
			</div>

			<h2>Autocompletar</h2>

			<p>
				Para autocompletar nicks, canais, comandos e emoji, escreve um dos caracteres abaixo
				para abrir uma lista de sugestões. Usa as teclas <kbd>↑</kbd> e <kbd>↓</kbd> para
				escolher um item, e insere-o pressionando <kbd>Tab</kbd> ou <kbd>Enter</kbd> (ou
				clicando no item desejado).
			</p>
			<p>
				O autocompletar pode ser desactivado nas definições.
			</p>

			<div class="help-item">
				<div class="subject">
					<code>@</code>
				</div>
				<div class="description">
					<p>Nick</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>#</code>
				</div>
				<div class="description">
					<p>Canal</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/</code>
				</div>
				<div class="description">
					<p>Comandos (ver lista de comandos abaixo)</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>:</code>
				</div>
				<div class="description">
					<p>
						Emoji (nota: necessita de dois caracteres de pesquisa, para evitar conflitos
						com emoticons comuns como <code>:)</code>)
					</p>
				</div>
			</div>

			<h2>Comandos</h2>

			<div class="help-item">
				<div class="subject">
					<code>/away [mensagem]</code>
				</div>
				<div class="description">
					<p>Activa o away com uma mensagem opcional.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/back</code>
				</div>
				<div class="description">
					<p>Remove o estado de away (definido com <code>/away</code>).</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/ban nick</code>
				</div>
				<div class="description">
					<p>
						Bane (<code>+b</code>) um utilizador do canal actual. O parâmetro pode ser
						um nick ou uma máscara.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/banlist</code>
				</div>
				<div class="description">
					<p>Mostra a lista de bans do canal actual.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/connect [host [port]]</code>
				</div>
				<div class="description">
					<p>
						Liga à rede de chat. Se <code>port</code> começar com o símbolo
						<code>+</code>, a ligação será protegida com TLS.
					</p>
					<p>Alias: <code>/server</code></p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/ctcp target cmd [args]</code>
				</div>
				<div class="description">
					<p>
						Envia um pedido <abbr title="Client-to-client protocol">CTCP</abbr>
						Podes ler mais sobre o CTCP
						<a
							href="https://en.wikipedia.org/wiki/Client-to-client_protocol"
							target="_blank"
							rel="noopener"
							>neste artigo da Wikipedia</a
						>.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/deop nick [...nick]</code>
				</div>
				<div class="description">
					<p>
						Remove op (<code>-o</code>) de um ou vários utilizadores do canal actual.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/devoice nick [...nick]</code>
				</div>
				<div class="description">
					<p>
						Remove voice (<code>-v</code>) de um ou vários utilizadores do canal actual.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/disconnect [mensagem]</code>
				</div>
				<div class="description">
					<p>
						Desliga o chat, opcionalmente com a mensagem indicada.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/invite nick [canal]</code>
				</div>
				<div class="description">
					<p>
						Convida o utilizador para o canal actual. Se <code>canal</code>
						for especificado, convida para esse canal.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/ignore nick</code>
				</div>
				<div class="description">
					<p>
						Bloqueia todas as mensagens do utilizador especificado. Pode ser um nick ou
						máscara.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/ignorelist</code>
				</div>
				<div class="description">
					<p>Mostra a lista de utilizadores ignorados.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/join canal</code>
				</div>
				<div class="description">
					<p>Entra no canal especificado.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/kick nick</code>
				</div>
				<div class="description">
					<p>Expulsa o utilizador do canal actual.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/list</code>
				</div>
				<div class="description">
					<p>Devolve a lista de canais disponíveis na rede.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/me mensagem</code>
				</div>
				<div class="description">
					<p>
						Envia uma acção para o canal actual. A mensagem será mostrada assumindo que
						foi escrita na terceira pessoa.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/mode modos [args]</code>
				</div>
				<div class="description">
					<p>
						Aplica os modos especificados ao canal actual se a janela activa for um
						canal, a outro utilizador se a janela activa for uma conversa privada, ou a
						ti próprio se a janela activa for a de status.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/msg canal mensagem</code>
				</div>
				<div class="description">
					<p>Envia a mensagem para o canal especificado.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/nick novonick</code>
				</div>
				<div class="description">
					<p>Altera o nick para o especificado.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/notice canal mensagem</code>
				</div>
				<div class="description">
					<p>Envia uma notificação para o canal especificado.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/op nick [...nick]</code>
				</div>
				<div class="description">
					<p>
						Dá op (<code>+o</code>) a um ou vários utilizadores do canal actual.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/part [canal]</code>
				</div>
				<div class="description">
					<p>
						Fecha a janela do canal ou conversa actual, ou do
						<code>canal</code> se for especificado.
					</p>
					<p>Aliases: <code>/close</code>, <code>/leave</code></p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/rejoin</code>
				</div>
				<div class="description">
					<p>
						Sai e reentra imediatamente no canal actual. Útil para rapidamente ganhar op
						do ChanServ ou num canal vazio, por exemplo.
					</p>
					<p>Alias: <code>/cycle</code></p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/query nick</code>
				</div>
				<div class="description">
					<p>Envia uma mensagem privada ao utilizador especificado.</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/quit [mensagem]</code>
				</div>
				<div class="description">
					<p>
						Desliga o chat, opcionalmente com a mensagem especificada.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/raw comando</code>
				</div>
				<div class="description">
					<p>Envia um comando directo para a rede.</p>
					<p>Aliases: <code>/quote</code>, <code>/send</code></p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/slap nick</code>
				</div>
				<div class="description">
					<p>Esbofeteia alguém no canal actual com uma truta! ;-)</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/topic [novotópico]</code>
				</div>
				<div class="description">
					<p>
						Mostra o tópico do canal actual. Se um <code>novotópico</code> for
						especificado, define-o como tópico do canal actual.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/unban nick</code>
				</div>
				<div class="description">
					<p>
						Desbane (<code>-b</code>) um utilizador do canal actual. Pode ser
						especificado um nick ou uma máscara.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/unignore nick</code>
				</div>
				<div class="description">
					<p>
						Desbloqueia a recepção de mensagens do utilizador especificado. Pode ser um
						nick ou uma máscara.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/voice nick [...nick]</code>
				</div>
				<div class="description">
					<p>
						Dá voice (<code>+v</code>) a um ou vários utilizadores do canal actual.
					</p>
				</div>
			</div>

			<div class="help-item">
				<div class="subject">
					<code>/whois nick</code>
				</div>
				<div class="description">
					<p>
						Mostra informações sobre o utilizador especificado.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SidebarToggle from "../SidebarToggle.vue";
import VersionChecker from "../VersionChecker.vue";

export default {
	name: "Help",
	components: {
		SidebarToggle,
		VersionChecker,
	},
	data() {
		return {
			isApple: navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i) || false,
		};
	},
};
</script>
